<template>
    <div class="card">
        <div class="card-header d-flex justify-content-between align-items-center">
            <h5 class="card-title mb-0">{{ $t('events') }}</h5>
            <button class="btn btn-primary" @click="openCreateModal">{{ $t('create') }}</button>
        </div>
        <div class="card-body">
            <app-table :id="tableId" :options="options" @action="getActionEvent"></app-table>

            <app-event-modal
                v-if="isModalActive"
                v-model="isModalActive"
                :selected-url="selectedUrl"
                @reload="reloadTable"
                @close="closeCreateModal"
            ></app-event-modal>
            <app-confirmation-modal
                modal-id="confirm-delete-modal"
                title="Are you sure?"
                message="This content will be deleted permanently."
                icon="x-circle"
                modal-class="danger"
                @confirmed="deleteEvent(deleteItemId)"
                @cancelled="cancelDelete"
                v-if="showDeleteConfirmModal"
            ></app-confirmation-modal>

        </div>
    </div>
</template>

<script>
import EventListLogMixin from "../../Mixins/EventListLogMixin";
import {urlGenerator} from "../../../../common/Helper/AxiosHelper";
import AppEventModal from "./Component/EventModal.vue";
import { EVENTS_LOG } from "../../../Config/ApiUrl";
import {axiosDelete} from "../../../../common/Helper/AxiosHelper";

export default {
    name: "EventList",
    mixins: [EventListLogMixin],
    components: {AppEventModal},
    data() {
        return {
            urlGenerator,
            tableId: 'event-list-table',
            selectedUrl: null,
            isModalActive: false,
            showDeleteConfirmModal: false,
            deleteItemId: null,
            options: {
                name: this.$t('event_list'),
                url: EVENTS_LOG,
                showHeader: true,
                showFilter: true,
                showSearch: true,
                showPagination: true,
                showAction: true,
                tableShadow: true,
                actionType: 'dropdown',
                resource: 'events',
                datatableId: 'event-list-table',
                columns: [
                    {
                        title: 'ID',
                        key: 'id',
                        isVisible: false
                    },
                    {
                        title: this.$t('date'),
                        type: 'text',
                        key: 'date',
                    },
                    {
                        title: this.$t('items'),
                        type: 'component',
                        componentName: 'item-list-view',
                        key: 'items',
                    },
                    {
                        title: this.$t('actions'),
                        type: 'action'
                    }
                ]
            }
        };
    },
    methods: {
        openCreateModal() {
            this.selectedUrl = null;
            this.isModalActive = true;
        },
        closeCreateModal() {
            this.selectedUrl = null;
            this.isModalActive = false;
        },
        reloadTable() {
            this.$hub.$emit('reload-' + this.tableId);
        },
        getActionEvent(row, action) {
            console.log('Action event received:', row, action);
            if (action.type === 'edit') {
                this.selectedUrl = `${EVENTS_LOG}/${row.id}`;
                this.isModalActive = true;
            } else if (action.type === 'delete') {
                this.deleteItemId = row.id;
                this.showDeleteConfirmModal = true;
            }
        },
        cancelDelete() {
            this.showDeleteConfirmModal = false;
            this.deleteItemId = null;
        },
        deleteEvent(id) {
            axiosDelete(`${EVENTS_LOG}/${id}`).then(({data}) => {
                this.$toastr.s(data.message);
                this.reloadTable();
            }).catch(error => {
                if (error.response) {
                    this.$toastr.e(error.response.data.message);
                }
            }).finally(() => {
                this.showDeleteConfirmModal = false;
                this.deleteItemId = null;
            });
        }
    },
};
</script>

